import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

// Import Forms elements
import BrandList from './BrandList';
import BrandsHolderPage from './BrandsHolderPage';
import SegmentsHolderPage from './SegmentsHolderPage';
import ActivityList from './ActivityList';
import SegmentList from './SegmentList';
import ApplicationList from './ApplicationList';
import FavoritesPage from './FavoritesPage';

// Registrations
import ReportsLoginTrends from './ReportsLoginTrends';
import ReportsCountryLogins from './ReportsCountryLogins';
import ReportsChannelLogins from './ReportsChannelLogins';
import ReportsLoginDomains from './ReportsLoginDomains';

// Reports
import ReportsForm from './ReportsForm';
import ReportsResults from './ReportsResults';
import ReportsCriteria from './ReportsCriteria';
import ReportsNavigation from './ReportsNavigation';
import ReportsActiveMembers from './ReportsActiveMembers';
import ReportsAllMembers from './ReportsAllMembers';
import ReportsLoginMembers from './ReportsLoginMembers';
import ReportsCrossoverBrands from './ReportsCrossoverBrands';
import ReportsChannelActivity from './ReportsChannelActivity';
import ReportsActivityTimeline from './ReportsActivityTimeline';
import ReportsCountryActivity from './ReportsCountryActivity';
import ReportsDailyRegistrations from './ReportsDailyRegistrations';
import ReportsSegmentOverviewMetrics from './ReportsSegmentOverviewMetrics';
import ReportsTopActivities from './ReportsTopActivities';
import DownloadReport from './DownloadReport';

// Integrations
import IntegrationsPageAudienceSize from './IntegrationsPageAudienceSize';
import IntegrationsPageBuildStatus from './IntegrationsPageBuildStatus';

//Privacy Center
import GrantsPage from './GrantsPage';

import reportWebVitals from './reportWebVitals';

// Function to render a component if the target element is found
const renderComponent = (Component, elementId, props = {}) => {
  const element = document.getElementById(elementId);
  if (element) {
    ReactDOM.render(
      <React.StrictMode>
        <Component {...props} />
      </React.StrictMode>,
      element
    );
  }
};

// Render Components
renderComponent(BrandList, 'BrandList', {
  maxBrands: document.getElementById('BrandList')?.getAttribute("maxbrands"),
  page: document.getElementById('BrandList')?.getAttribute("page"),
});

renderComponent(BrandsHolderPage, 'BrandsHolder');
renderComponent(SegmentsHolderPage, 'SegmentsHolder');
renderComponent(ApplicationList, 'ApplicationList');
renderComponent(SegmentList, 'SegmentList', {
  type: document.getElementById('SegmentList')?.getAttribute("type"),
});

// Render multiple ActivityList components
const activityFields = document.getElementsByClassName('ActivityList');
Array.from(activityFields).forEach((activityField) => {
  const type = activityField.getAttribute('type');
  ReactDOM.render(
    <React.StrictMode>
      <ActivityList type={type} />
    </React.StrictMode>,
    activityField
  );
});

renderComponent(ReportsForm, 'ReportsForm');
renderComponent(ReportsResults, 'ReportsResults');
renderComponent(ReportsActiveMembers, 'ReportsActiveMembers', {
  type: document.getElementById('ReportsActiveMembers')?.getAttribute("type"),
});
renderComponent(ReportsAllMembers, 'ReportsAllMembers', {
  type: document.getElementById('ReportsAllMembers')?.getAttribute("type"),
});
renderComponent(ReportsLoginMembers, 'ReportsLoginMembers', {
  type: document.getElementById('ReportsLoginMembers')?.getAttribute("type"),
});
renderComponent(FavoritesPage, 'FavoritesPage');

// Registrations Pages
renderComponent(ReportsLoginTrends, 'ReportsLoginTrends');
renderComponent(ReportsCountryLogins, 'ReportsCountryLogins');
renderComponent(ReportsLoginDomains, 'ReportsLoginDomains');

// Reports Pages
renderComponent(ReportsNavigation, 'ReportsNavigation');
renderComponent(ReportsCriteria, 'ReportsCriteria');
renderComponent(ReportsCriteria, 'FavoriteReportsCriteria');
renderComponent(ReportsCrossoverBrands, 'ReportsCrossoverBrands');
renderComponent(ReportsDailyRegistrations, 'ReportsDailyRegistrations');
renderComponent(ReportsTopActivities, 'ReportsTopActivities');
renderComponent(ReportsChannelActivity, 'ReportsChannelActivity');
renderComponent(ReportsActivityTimeline, 'ReportsActivityTimeline');
renderComponent(ReportsCountryActivity, 'ReportsCountryActivity');
renderComponent(ReportsChannelLogins, 'ReportsChannelLogins');
renderComponent(ReportsSegmentOverviewMetrics, 'ReportsSegmentOverviewMetrics');

// Integrations Pages
renderComponent(IntegrationsPageAudienceSize, 'AudienceSize');
renderComponent(IntegrationsPageBuildStatus, 'IntegrationStatus');

//Privacy Center
renderComponent(GrantsPage, 'GrantsPage');

// Users Pages
renderComponent(DownloadReport, 'DownloadReport');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
